import { Dispatch, SetStateAction, useEffect, useState } from 'react';

/**
 * useState 드롭인 대체 훅.
 * 값을 sessionStorage에 저장해 새로고침(환불 후 window.location.reload 등) 후에도 유지한다.
 * - 탭 세션 동안만 유지(탭/브라우저 종료 시 소멸)되므로 핸드폰번호 등 개인정보 검색어에 적합.
 * - 저장/복원에 실패해도 기본값으로 안전하게 동작.
 */
export function useSessionPersistedState<T>(
  key: string,
  defaultValue: T,
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      const saved = sessionStorage.getItem(key);
      if (saved != null) return JSON.parse(saved) as T;
    } catch {
      // 손상된 값은 무시하고 기본값 사용
    }
    return defaultValue;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // 저장 실패(용량 초과 등)는 무시 — 기능 동작에는 영향 없음
    }
  }, [key, value]);

  return [value, setValue];
}
